<template>
  <v-card>
    <v-card-title>
      <h2 class="modal-title">{{ 'activities.add_client' | translate }}</h2>
    </v-card-title>

    <v-card-content>
      <div class="form">
        <div class="form-row">
          <div class="form-column">
            <div class="form-element">
              <v-input-r v-model="form.first_name" :label="$t('base.first_name')" :hint="errorMessage('first_name')"
                 :invalid="!!errorMessage('first_name')" @input="clearFieldError('first_name')" autocomplete="given-name" />
            </div>
          </div>
          <div class="form-column">
            <div class="form-element">
              <v-input-r v-model="form.phone" :label="$t('base.phone')" :hint="errorMessage('phone')"
                :invalid="!!errorMessage('phone')" @input="clearFieldError('phone')" autocomplete="tel" />
            </div>
          </div>
        </div>

        <div class="form-row">
          <div class="form-column">
            <div class="form-element">
              <v-input-r v-model="form.last_name" :label="$t('base.last_name')" :hint="errorMessage('last_name')"
                :invalid="!!errorMessage('last_name')" @input="clearFieldError('last_name')" autocomplete="family-name" />
            </div>
          </div>
          <div class="form-column">
            <div class="form-element">
              <v-input-r v-model="form.email" :label="$t('base.email')" :hint="errorMessage('email')"
                :invalid="!!errorMessage('email')" @input="clearFieldError('email')" autocomplete="email" />
            </div>
          </div>
        </div>

        <div class="form-row">
          <div class="form-column">
            <div class="form-element">
              <v-input-r v-model="form.company_name" :label="$t('base.company_name')" :hint="errorMessage('company_name')"
                :invalid="!!errorMessage('company_name')" @input="clearFieldError('company_name')" autocomplete="organization" />
            </div>
          </div>
          <div class="form-column">
            <div class="form-element">
              <v-input-r v-model="form.password" :label="$t('base.password')" type="password"
                :hint="errorMessage('password')" :invalid="!!errorMessage('password')"
                @input="clearFieldError('password')" autocomplete="new-password" />
            </div>
          </div>
        </div>

        <div class="form-row">
          <div class="form-column">
            <div class="form-element">
              <v-input-r v-model="form.profile.about" :label="$t('base.about_client')" />
            </div>
          </div>
          <div class="form-column">
            <div class="form-element">
              <v-select v-model="form.profile.group" :options="countries" :label="$t('base.country')"
                :hint="errorMessage('group')" :invalid="!!errorMessage('group')" :loading="loadingCountries"
                item-text="name" item-value="id" @input="clearFieldError('group')" />
            </div>
          </div>
        </div>

        <div class="form-row">
          <div class="form-column">
            <div class="form-element">
              <v-select item-value="key" :label="$t('base.select_lang')" :options="languages"
                v-model="form.profile.language" :hint="errorMessage('language')" :invalid="!!errorMessage('language')"
                @input="clearFieldError('language')" />
            </div>
          </div>
          <div class="form-column">
            <div class="form-element">
              <div class="access-switch mt-4">
                <span>{{ 'activities.access_kkz' | translate }}</span>
                <v-switch v-model="form.kkz" inset />
              </div>
            </div>
          </div>
        </div>

      </div>
    </v-card-content>
    <v-card-actions>
      <v-btn :disabled="!isFormFilled" :loading="loading" @click="submit">
        {{ $t('base.save') }}
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import formErrorsMixin from '@/mixins/form-errors.mixin.js'

export default {
  name: 'CreateClientModal',
  mixins: [formErrorsMixin],
  data () {
    return {
      loading: false,
      loadingCountries: false,

      form: {
        email: '',
        password: '',
        first_name: '',
        last_name: '',
        phone: '',
        user_type: 'client',
        company_name: '',
        profile: {
          about: '',
          language: null,
          group: null,
        },
        profeed: true,
        kkz: true
      },
      errors: null,
      languages: [
        { id: 0, name: 'Українська', key: 'uk' },
        { id: 1, name: 'Русский', key: 'ru' },
        { id: 2, name: 'Polski', key: 'pl' },
        { id: 3, name: 'English', key: 'en' },
        { id: 4, name: 'Eesti', key: 'et' },
        { id: 5, name: 'Ελληνικά', key: 'el' },
        { id: 6, name: 'Español', key: 'es' },
        { id: 7, name: 'Español (US)', key: 'es-us' },
        { id: 8, name: 'Netherlands', key: 'nl' },
        { id: 9, name: 'Deutsch', key: 'de' },
        { id: 10, name: 'Français', key: 'fr' },
        { id: 11, name: 'Italiano', key: 'it' },
        { id: 12, name: 'Română', key: 'ro' },
        { id: 13, name: 'USA', key: 'us' },
      ],
    }
  },
  computed: {
    ...mapGetters('countriesGroups', ['countriesGroups']),

    isFormFilled () {
      return !!(
        this.form.first_name &&
        this.form.last_name &&
        this.form.phone &&
        this.form.email &&
        this.form.company_name &&
        this.form.password && this.form.password.length >= 8 &&
        this.form.profile.group &&
        this.form.profile.language
      )
    },

    countries () {
      if (!this.countriesGroups.length) {
        return []
      }
      return this.countriesGroups.map(country => ({
        id: country.id,
        name: country.name
      }))
    }
  },
  async mounted () {
    await this.loadCountries()
  },
  methods: {
    ...mapActions('countriesGroups', ['loadCountriesGroups']),
    ...mapActions('dashboard', ['createUser']),

    async loadCountries () {
      this.loadingCountries = true
      try {
        await this.loadCountriesGroups()
        const ukraine = this.countries.find(c => c.name === 'Ukraine')
        if (ukraine && !this.form.profile.group) {
          this.form.profile.group = ukraine.id
        }
      } catch (error) {
        console.error('Помилка завантаження країн:', error)
      } finally {
        this.loadingCountries = false
      }
    },

    clearFieldError (fieldName) {
      if (this.errors && this.errors[fieldName]) {
        this.$set(this.errors, fieldName, null)
      }
    },

    validate () {
      this.errors = {}

      if (!this.form.first_name) {
        this.errors.first_name = ['3']
      }

      if (!this.form.last_name) {
        this.errors.last_name = ['3']
      }

      if (!this.form.phone) {
        this.errors.phone = ['3']
      }

      if (!this.form.email) {
        this.errors.email = ['3']
      }

      if (!this.form.company_name) {
        this.errors.company_name = ['3']
      }

      if (!this.form.password) {
        this.errors.password = ['3']
      } else if (this.form.password.length < 8) {
        this.errors.password = ['6', 8] // код для "мінімальна довжина" з лімітом 8
      }

      if (!this.form.profile.group) {
        this.errors.group = ['3']
      }

      if (!this.form.profile.language) {
        this.errors.language = ['3']
      }

      return Object.keys(this.errors).length === 0
    },

    async submit () {
      if (!this.validate()) return

      this.loading = true

      try {
        const payload = {
          email: this.form.email,
          password: this.form.password,
          first_name: this.form.first_name,
          last_name: this.form.last_name,
          phone: this.form.phone,
          is_active: true,
          user_type: this.form.user_type,
          display_name: this.form.company_name,
          profile: {
            about: this.form.profile.about,
            language: this.form.profile.language,
            group: this.form.profile.group
          },
          modules: []
        }

        if (this.form.profeed) {
          payload.modules.push('profeed')
        }
        if (this.form.kkz) {
          payload.modules.push('animalfeed')
        }

        const errors = await this.createUser(payload)

        if (!errors) {
          this.$toasted.success('Клієнта успішно створено!')
          this.$emit('update')
          this.$emit('close')
        } else {
          this.errors = errors

          if (errors.email) {
            this.$toasted.error('Некоректний email!')
          } else if (errors.phone) {
            this.$toasted.error('Некоректний номер телефону!')
          } else if (errors.password) {
            this.$toasted.error('Некоректний пароль!')
          } else {
            this.$toasted.error('Сталася помилка при створенні клієнта!')
          }
        }
      } catch (err) {
        console.error('Помилка при збереженні:', err)
        this.$toasted.error('Помилка при збереженні')
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style scoped>
.v-card__title {
  padding: 2rem 2.4rem 1.6rem;
}

.modal-title {
  font-size: 2rem;
  font-weight: 700;
  margin: 0;
}

.v-card__content {
  border-top: .1rem solid #d7d7d7;
  padding-bottom: 1.5rem !important;
}

.v-card__actions {
  padding: 0 2.4rem 2.4rem;
}

.v-card__actions button {
  width: 100%;
}

.form {
  display: flex;
  flex-direction: column;
}

.form-row {
  display: flex;
  gap: 40px;
  width: 100%;
}

.form-column {
  flex: 1;
  min-width: 0;
}

.form-element {
  width: 100%;
}

.access-switch {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 0;
}

@media (max-width: 768px) {
  .form-row {
    flex-direction: column;
    gap: 12px;
  }
}
</style>